import platform from '@tencent/wphk-platform-adapter';
import * as cache from './cache';

/** Cookie 名称常量 */
export const COOKIE_NAME_WALLET_OPENID = 'wallet_openid';
export const COOKIE_NAME_QL_UIN = 'qluin';

/** UIN 本地缓存 key */
export const CACHE_KEY_UIN = 'WPHK_UIN';

/** 从 cookie 获取 UIN */
export function getUin() {
  const wphkUin = platform.getCookie(COOKIE_NAME_WALLET_OPENID);
  const qlUin = platform.getCookie(COOKIE_NAME_QL_UIN);
  return wphkUin || qlUin;
}

/** 将 UIN 写入本地缓存 */
export function setUinCache(uin: string) {
  cache.setItem(CACHE_KEY_UIN, uin);
}

/**
 * 异步获取 UIN：优先读取本地缓存，缓存为空时兜底读取 cookie。
 * 读取到 cookie 中的 UIN 后会写入缓存，供下次优先读取。
 * 适用于 cookie 可能延迟写入或不稳定（如 LiteApp store）等场景。
 */
export async function getUinAsync(): Promise<string> {
  const cacheUin = (await cache.getItem<string>(CACHE_KEY_UIN)) || '';
  if (cacheUin) {
    return cacheUin;
  }
  const cookieUin = getUin() || '';
  if (cookieUin) {
    setUinCache(cookieUin);
  }
  return cookieUin;
}
